export default "__VITE_ASSET__zTk64WXx__"